// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__38fQ6","productName":"Table_productName__dewjd"};